import { createQueryAtomFactory } from '~/shared/providers/api/createQueryAtomFactory';

export const facilitiesQueryAtom = createQueryAtomFactory(
  'inventory.facilities',
  () => ({
    facilities: {
      __args: {
        pagination: {
          limit: 100,
          offset: 0,
        },
      },
      entries: {
        id: true,
        facilityName: true,
      },
    },
  }),
  {
    select: (data) => {
      if (!data || !data.facilities || !data.facilities.entries) {
        return { facilities: [] };
      }

      return {
        facilities: data.facilities.entries.map((facility) => ({
          id: facility.id,
          name: facility.facilityName || '',
        })),
      };
    },
  },
);
